module.exports = __webpack_public_path__ + "static/img/u69.907e6e34.png";